import _ from 'lodash';
import Cookies from 'js-cookie';
import { fabric } from 'fabric';
import { Common } from '@src/common';
import textAnimation from '@action/text_animation';
import animationJSON from '@action/text_animation_info';
import bannerJSON from '@action/banner_info';

const animationInit = {
  lang: Cookies.get(Common.STORAGE_LANG),
};

export const setCanvasSetting = (canvasId, { width, height }) => {
  const canvasInstance = new fabric.Canvas(canvasId, {
    width,
    height,
    hoverCursor: 'default',
  });

  return canvasInstance;
};

export const setTextSetting = () => {
  const fontFamily =
    animationInit.lang === Common.CONST_LANG_JA
      ? 'MeiryoBold'
      : 'NotoSansKRBlack';
  const textInstance = new fabric.IText('', {
    selectable: false,
    fontFamily,
    fontWeight: 800,
    fontSize: 32,
    textAlign: 'center',
    strokeWidth: 1,
    fill: '#ffffff',
    stroke: '#000000',
  });

  return textInstance;
};

export const setFontSize = (data, textInfo) => {
  const idx = data.clicked_text ? data.clicked_text - 1 : 0;
  const { model } = data.product_type_info;
  const {
    text_size_type: fontSizeType,
    text_size_type_second: fontSizeTypeSecond,
  } = textInfo;

  if (data.isBannerCondition) {
    // 배너 타입 전광판인 경우
    const firstLineType = textInfo.text_size_type;
    const secondLineType = textInfo.text_size_type_second;
    const lineType =
      textInfo.multi_line_yn === 'Y' ? 'multi_line' : 'single_line';

    data.fbText.fontSize = bannerJSON.text_size[model][lineType][firstLineType];
    data.fbTextSecondLine.fontSize =
      bannerJSON.text_size[model][lineType][secondLineType];
    if (data.isMultiCanvas) {
      data.cloneFirstLine.fontSize =
        bannerJSON.text_size[model][lineType][firstLineType];
      data.cloneSecondLine.fontSize =
        bannerJSON.text_size[model][lineType][secondLineType];
    }
    return;
  }

  if (data.animation_preset && data.animation_preset[idx]) {
    // 테마에 등록된 사전 정의 정보가 있는경우
    const item = data.animation_preset[idx];
    const condition =
      data.height === item.v_res &&
      data.width === item.h_res &&
      data.rotate === item.rotate;

    const firstLineFontSize = item.font_size[fontSizeType][animationInit.lang]
      ? item.font_size[fontSizeType][animationInit.lang]
      : item.font_size[fontSizeType];
    let secondLineFontSize;
    if (textInfo.multi_line_yn === 2) {
      secondLineFontSize = item.font_size[fontSizeTypeSecond][
        animationInit.lang
      ]
        ? item.font_size[fontSizeTypeSecond][animationInit.lang]
        : item.font_size[fontSizeType];
    }

    if (condition && textInfo.multi_line_yn === 1) {
      // 한 줄을 사용하는 경우 (first_line, second_line의 폰트크기가 각각 지정된 경우와 아닌경우를 구분하여 저장)
      data.fbText.fontSize = firstLineFontSize;
      if (data.isMultiCanvas) data.cloneFirstLine.fontSize = firstLineFontSize;
    } else if (condition && textInfo.multi_line_yn === 2) {
      // 두 줄을 사용하는 경우 (first_line, second_line의 폰트크기가 각각 지정된 경우와 아닌경우를 구분하여 저장)
      data.fbText.fontSize = firstLineFontSize;
      data.fbTextSecondLine.fontSize = secondLineFontSize;
      if (data.isMultiCanvas) {
        data.cloneFirstLine.fontSize = firstLineFontSize;
        data.cloneSecondLine.fontSize = secondLineFontSize;
      }
    }
    return;
  }

  // 테마에 등록된 사전 정의 정보가 없는경우
  const animationInfo = animationJSON[model].find((signInfo) => {
    const multiLineCondition =
      textInfo.multi_line_yn === 'Y'
        ? signInfo.multi_line_type === 2
        : signInfo.multi_line_type === 1;

    return (
      data.height === signInfo.v_res &&
      data.width === signInfo.h_res &&
      data.rotate === signInfo.rotate &&
      multiLineCondition
    );
  });
  // 두 줄을 사용하는 경우 (first_line, second_line의 폰트크기가 각각 지정된 경우와 아닌경우를 구분하여 저장)
  data.fbText.fontSize =
    animationInfo.font_size[fontSizeType][animationInit.lang];
  if (textInfo.multi_line_yn === 'Y') {
    data.fbTextSecondLine.fontSize =
      animationInfo.font_size[fontSizeTypeSecond][animationInit.lang];
  }
  if (data.isMultiCanvas) {
    data.cloneFirstLine.fontSize =
      animationInfo.font_size[fontSizeType][animationInit.lang];
  }
  if (textInfo.multi_line_yn === 'Y' && data.isMultiCanvas) {
    data.cloneSecondLine.fontSize =
      animationInfo.font_size[fontSizeTypeSecond][animationInit.lang];
  }

  if (textInfo.multi_line_yn === 'N') {
    data.fbText.fontSize *= 2;
    if (data.isMultiCanvas) data.cloneFirstLine.fontSize *= 2;
  }
};

const bannerSignTextLimit = (data, idx = 0) => {
  const { model } = data.product_type_info;
  const lineType =
    data.text_list[idx].multi_line_yn === 'Y' ? 'multi_line' : 'single_line';
  const firstLineType = data.text_list[idx].text_size_type;
  const secondLineType = data.text_list[idx].text_size_type_second;

  data.text_list[idx].first_line_limit =
    bannerJSON.text_limit[model][data.product_type_id][lineType][firstLineType];
  data.text_list[idx].second_line_limit =
    bannerJSON.text_limit[model][data.product_type_id][lineType][
      secondLineType
    ];
};

const isBigTextSignType = (productTypeId, item) => {
  const bigTextSignType = [
    'H044391',
    'H081391',
    'H120391',
    'H044625',
    'H081625',
    'H120625',
  ];
  const bigTextSignCondition =
    item.text_size_type === 'large' &&
    item.multi_line_yn === 'N' &&
    (item.animation_name === 'slide_left' ||
      item.animation_name === 'slide_right');
  return bigTextSignType.indexOf(productTypeId) !== -1 && bigTextSignCondition;
};

const isDynamicAnimationCondition = (data, animationName) => {
  return (
    data.isVerticalAnimationCondition &&
    (animationName === 'slide_top' || animationName === 'slide_bottom')
  );
};

export const setTextLimit = (productInfo, data) => {
  const idx = data.clicked_text ? data.clicked_text - 1 : 0;
  // 테마이면서 사전 등록된 애니메이션 설정(data.animation_preset)이 있는 경우 해당 정보를 사용하고,
  // 아닌 경우 기본 애니메이션 설정(animationJSON)을 사용
  const { model } = data.product_type_info;
  const {
    text_size_type: textSizeType,
    text_size_type_second: textSizeTypeSecond,
  } = data.text_list[idx];

  if (!data.isBannerCondition) {
    animationJSON[model].forEach((item) => {
      if (
        productInfo.h_res === item.h_res &&
        productInfo.v_res === item.v_res &&
        productInfo.rotate === item.rotate
      ) {
        const isMultiLine = item.multi_line_type === 2 ? 'Y' : 'N';
        if (isMultiLine === data.text_list[idx].multi_line_yn) {
          data.text_list[idx].first_line_limit =
            item.text_limit[textSizeType][animationInit.lang];
          data.text_list[idx].second_line_limit =
            item.text_limit[textSizeTypeSecond][animationInit.lang];

          if (
            !data.isShowTab &&
            !isDynamicAnimationCondition(
              data,
              data.text_list[idx].animation_name,
            )
          ) {
            const unit = 1.5;
            data.text_list[idx].first_line_limit = Math.floor(
              data.text_list[idx].first_line_limit * unit,
            );
            data.text_list[idx].second_line_limit = Math.floor(
              data.text_list[idx].second_line_limit * unit,
            );

            if (productInfo.h_res === 256 && productInfo.v_res === 128) {
              if (textSizeType === 'large')
                data.text_list[idx].first_line_limit = 10;
              else if (textSizeType === 'midium')
                data.text_list[idx].first_line_limit = 16;
              else if (textSizeType === 'small')
                data.text_list[idx].first_line_limit = 20;
              if (textSizeTypeSecond === 'large')
                data.text_list[idx].second_line_limit = 10;
              else if (textSizeTypeSecond === 'midium')
                data.text_list[idx].second_line_limit = 16;
              else if (textSizeTypeSecond === 'small')
                data.text_list[idx].second_line_limit = 20;
            } else if (productInfo.h_res === 256 && productInfo.v_res === 256) {
              if (textSizeType === 'large')
                data.text_list[idx].first_line_limit = 20;
              else if (textSizeType === 'midium')
                data.text_list[idx].first_line_limit = 30;
              else if (textSizeType === 'small')
                data.text_list[idx].first_line_limit = 40;
              if (textSizeTypeSecond === 'large')
                data.text_list[idx].second_line_limit = 20;
              else if (textSizeTypeSecond === 'midium')
                data.text_list[idx].second_line_limit = 30;
              else if (textSizeTypeSecond === 'small')
                data.text_list[idx].second_line_limit = 40;
            } else if (productInfo.h_res === 320 && productInfo.v_res === 64) {
              if (textSizeType === 'large')
                data.text_list[idx].first_line_limit = 7;
              else if (textSizeType === 'midium')
                data.text_list[idx].first_line_limit = 13;
              else if (textSizeType === 'small')
                data.text_list[idx].first_line_limit = 20;
              if (textSizeTypeSecond === 'large')
                data.text_list[idx].second_line_limit = 7;
              else if (textSizeTypeSecond === 'midium')
                data.text_list[idx].second_line_limit = 13;
              else if (textSizeTypeSecond === 'small')
                data.text_list[idx].second_line_limit = 20;
            } else if (productInfo.h_res === 512) {
              if (textSizeType === 'large')
                data.text_list[idx].first_line_limit = 11;
              else if (textSizeType === 'midium')
                data.text_list[idx].first_line_limit = 13;
              else if (textSizeType === 'small')
                data.text_list[idx].first_line_limit = 20;
              if (textSizeTypeSecond === 'large')
                data.text_list[idx].second_line_limit = 11;
              else if (textSizeTypeSecond === 'midium')
                data.text_list[idx].second_line_limit = 13;
              else if (textSizeTypeSecond === 'small')
                data.text_list[idx].second_line_limit = 20;
            } else if (productInfo.h_res === 768) {
              if (textSizeType === 'large')
                data.text_list[idx].first_line_limit = 17;
              else if (textSizeType === 'midium')
                data.text_list[idx].first_line_limit = 21;
              else if (textSizeType === 'small')
                data.text_list[idx].first_line_limit = 30;
              if (textSizeTypeSecond === 'large')
                data.text_list[idx].second_line_limit = 17;
              else if (textSizeTypeSecond === 'midium')
                data.text_list[idx].second_line_limit = 21;
              else if (textSizeTypeSecond === 'small')
                data.text_list[idx].second_line_limit = 30;
            }
          }

          if (
            isDynamicAnimationCondition(
              data,
              data.text_list[idx].animation_name,
            ) ||
            isBigTextSignType(data.product_type_id, data.text_list[idx])
          ) {
            if (model === 'AOM39101' && textSizeType === 'large') {
              data.text_list[idx].first_line_limit = 9;
            }
            if (model === 'AOM39101' && textSizeTypeSecond === 'large') {
              data.text_list[idx].second_line_limit = 9;
            }
            // 1x1세로 전광판이면서 애니메이션이 slide_top, slide_bottom인 경우
            // 또는 특정 전광판유형 + 1글자 큰글씨이면서 애니메이션이 slide_left, slide_right인경우
            // 글자수 제한 추가
            const unit = 2;
            data.text_list[idx].first_line_limit = Math.floor(
              item.text_limit[textSizeType][animationInit.lang] * unit,
            );
            data.text_list[idx].second_line_limit = Math.floor(
              item.text_limit[textSizeTypeSecond][animationInit.lang] * unit,
            );

            if (
              isDynamicAnimationCondition(
                data,
                data.text_list[idx].animation_name,
              ) &&
              data.text_list[idx].multi_line_yn === 'N'
            ) {
              data.text_list[idx].first_line_limit = 9;
              data.text_list[idx].second_line_limit = 9;
            }
          }
        }
      }
    });
  } else if (data.isBannerCondition) {
    // 배너타입인경우
    bannerSignTextLimit(data, idx);
  }
  // 애니메이션 변경 시 변경된 글자 수로 자르도록 함
  data.text_list[idx].first_line = data.text_list[idx].first_line.substr(
    0,
    data.text_list[idx].first_line_limit,
  );
  data.text_list[idx].second_line = data.text_list[idx].second_line.substr(
    0,
    data.text_list[idx].second_line_limit,
  );
};

export const setTextAnimation = (data, textInfo, animationName, diffTime) => {
  const slideEffectArr = [
    'slide_top',
    'slide_bottom',
    'slide_left',
    'slide_right',
  ];
  const scaleEffectArr = ['scale_in', 'scale_out'];
  const driftEffectArr = [
    'drift_top',
    'drift_bottom',
    'drift_left',
    'drift_right',
  ];

  if (animationName === 'static') textAnimation.staticAnimation(data, textInfo);
  if (slideEffectArr.includes(animationName))
    textAnimation.slideAnimation(data, textInfo, diffTime);
  if (animationName === 'fade') textAnimation.fadeAnimation(data, textInfo);
  if (scaleEffectArr.includes(animationName))
    textAnimation.scaleAnimation(data, textInfo, data.fbText.fontSize);
  if (driftEffectArr.includes(animationName))
    textAnimation.driftAnimation(data, textInfo, diffTime);
};

export const verticalAnimationText = (
  data,
  textInfo,
  animationName,
  diffTime,
) => {
  textInfo.animate_first_line = '';
  textInfo.animate_second_line = '';

  if (data.isVerticalAnimationCondition) {
    _.forEach(textInfo.first_line, (__, i) => {
      if (textInfo.first_line[i] === '-' || textInfo.first_line[i] === '－')
        textInfo.animate_first_line += `|\n`;
      else textInfo.animate_first_line += `${textInfo.first_line[i]}\n`;
    });
    _.forEach(textInfo.second_line, (__, j) => {
      if (textInfo.second_line[j] === '-' || textInfo.second_line[j] === '－')
        textInfo.animate_second_line += `|\n`;
      else textInfo.animate_second_line += `${textInfo.second_line[j]}\n`;
    });
  }

  const firstLineLenght = _.size(textInfo.first_line);
  const secondLineLength = _.size(textInfo.second_line);
  const addEnter = (a, b = a) => '\n'.repeat(a - b);

  if (firstLineLenght >= secondLineLength) {
    textInfo.animate_second_line += addEnter(
      firstLineLenght - secondLineLength,
    );
  } else {
    textInfo.animate_first_line += addEnter(secondLineLength - firstLineLenght);
  }

  setTextAnimation(data, textInfo, animationName, diffTime);
};

export const textListInit = (data, animations) => {
  const initAnimation = ['static', 'static', 'static'];
  const initMultiLineDefault = ['Y', 'Y', 'Y'];
  const initFontSizeType = ['small', 'small', 'small'];
  const initLineLimit = [13, 13, 13];
  const initVerticalAlign = ['center', 'center', 'center'];
  data.animation_preset = [];

  if (!data.isBannerCondition) {
    if (animations && animations.length > 0) {
      animations.forEach((list, index) => {
        const item = list.contents_json;
        if (item.animation_type_default)
          initAnimation[index] = item.animation_type_default;
        if (item.font_size_default)
          initFontSizeType[index] = item.font_size_default;
        if (item.vertical_align_default)
          initVerticalAlign[index] = item.vertical_align_default;

        if (
          item.animation_type_default &&
          item.font_size_default &&
          item.vertical_align_default
        ) {
          data.animation_preset[index] = item;
        } else {
          data.animation_preset[index] = undefined;
        }
      });
    } else {
      data.animation_preset = undefined;
      const { model } = data.product_type_info;
      animationJSON[model] = _.forEach(
        _.cloneDeep(animationJSON[model]),
        (item) => {
          if (
            item.h_res === data.product_type_info.h_res &&
            item.v_res === data.product_type_info.v_res
          ) {
            let idx = 0;

            if (item.multi_line_default === 'Y' && item.multi_line_type === 2) {
              for (idx = 1; idx < data.text_list_len; idx += 1) {
                initFontSizeType[idx] = item.font_size_default;
                initLineLimit[idx] =
                  item.text_limit[item.font_size_default][animationInit.lang];
              }
            } else if (
              item.multi_line_default === 'N' &&
              item.multi_line_type === 1
            ) {
              for (idx = 1; idx < data.text_list_len; idx += 1) {
                initFontSizeType[idx] = item.font_size_default;
                initLineLimit[idx] =
                  item.text_limit[item.font_size_default][animationInit.lang];
                initMultiLineDefault[idx] = 'N';
              }
            }
          }
        },
      );
    }
  }

  /* 문구 입력 설정 초기화 */
  data.text_list = [
    {
      index: 1,
      animation_name: initAnimation[0],
      border_color: '#000000',
      border_color_hex: '#000000',
      color_hex: '#FFFFFF',
      first_line: '',
      default_text: '',
      multi_line_yn: initMultiLineDefault[0],
      second_line: '',
      start_sec: 0,
      text_size_type: initFontSizeType[0],
      text_size_type_second: initFontSizeType[0],
      first_line_limit: initLineLimit[0],
      second_line_limit: initLineLimit[0],
      textVerticalAlign: initVerticalAlign[0],
      started: false,
    },
    {
      index: 2,
      animation_name: initAnimation[1],
      border_color: '#000000',
      border_color_hex: '#000000',
      color_hex: '#FFFFFF',
      first_line: '',
      default_text: '',
      multi_line_yn: initMultiLineDefault[1],
      second_line: '',
      start_sec: data.duration * 0.33,
      text_size_type: initFontSizeType[1],
      text_size_type_second: initFontSizeType[1],
      first_line_limit: initLineLimit[1],
      second_line_limit: initLineLimit[1],
      textVerticalAlign: initVerticalAlign[1],
      started: false,
    },
    {
      index: 3,
      animation_name: initAnimation[2],
      border_color: '#000000',
      border_color_hex: '#000000',
      color_hex: '#FFFFFF',
      first_line: '',
      default_text: '',
      multi_line_yn: initMultiLineDefault[2],
      second_line: '',
      start_sec: data.duration * 0.66,
      text_size_type: initFontSizeType[2],
      text_size_type_second: initFontSizeType[2],
      first_line_limit: initLineLimit[2],
      second_line_limit: initLineLimit[2],
      textVerticalAlign: initVerticalAlign[2],
      started: false,
    },
  ];

  if (data.animation_preset && data.animation_preset[0]) {
    if (!data.animation_preset[0].text_position.first_line.midium)
      data.fontSizeBlockList = ['midium'];
  }

  if (data.isBannerCondition) {
    data.opt_txt_effect = ['static', 'drift_bottom'];

    data.text_list.forEach((list, idx) => {
      list.multi_line_yn = 'Y';
      list.text_size_type = 'large';
      list.text_size_type_second = 'large';
      bannerSignTextLimit(data, idx);
    });
  } else {
    data.opt_txt_effect = [
      'slide_top',
      'slide_bottom',
      'slide_left',
      'slide_right',
      'static',
      'fade',
      'drift_top',
      'drift_bottom',
      'drift_left',
      'drift_right',
      'scale_in',
      'scale_out',
    ];
  }
};

// 사전정의 애니메이션에서 폰트사이즈 지원하지 않는 경우 해당 폰트 선택안되도록 함
const checkBlockFontSize = (data) => {
  data.fontSizeBlockList = [];
  const {
    product_type_info: { h_res: signWidth, v_res: signHeght, rotate },
  } = data;
  const idx = data.clicked_text ? data.clicked_text - 1 : 0;
  const isMultiLine = data.text_list[idx].multi_line_yn === 'Y';

  const setFontSizeTypeTo = (to) => {
    if (data.fontSizeBlockList.includes(data.text_list[idx].text_size_type)) {
      data.text_list[idx].text_size_type = to;
    }
    if (
      data.fontSizeBlockList.includes(data.text_list[idx].text_size_type_second)
    ) {
      data.text_list[idx].text_size_type_second = to;
    }
  };

  if (
    (signWidth === 480 && signHeght === 80 && rotate === 'H') ||
    (signWidth === 320 && signHeght === 80 && rotate === 'H') ||
    (signWidth === 160 && signHeght === 80 && rotate === 'H') ||
    (signWidth === 80 && signHeght === 160 && rotate === 'V')
  ) {
    if (isMultiLine) {
      data.fontSizeBlockList = ['large'];
      setFontSizeTypeTo('small');
    }
  }

  if (data.isBannerCondition) {
    data.fontSizeBlockList = ['small'];
    // @ts-ignore
    setFontSizeTypeTo(['small'], 'large');
  }

  if (signWidth === 320 && signHeght === 64 && rotate === 'V') {
    // S080600 타입인경우 큰글씨 1줄 / 작은 글씨 2줄만 허용
    data.fontSizeBlockList = ['small'];
    setFontSizeTypeTo('large');

    if (isMultiLine) {
      data.fontSizeBlockList = ['midium', 'large'];
      setFontSizeTypeTo('small');
    }
  }
};

export default {
  setCanvasSetting,
  setTextSetting,
  setFontSize,
  setTextLimit,
  textListInit,
  verticalAnimationText,
  setTextAnimation,
  checkBlockFontSize,
  bannerSignTextLimit,
};
